<template>
  <q-dialog v-model="open" @hide="$emit('helper-closed')">
    <q-card class="helper-card">
      <q-bar class="bar">
        <div class="col text-center text-weight-bold header">
          {{ $t("navigation.title") }}
        </div>
        <q-btn
          dense
          flat
          icon="close"
          class="close-button text-weight-bold"
          :aria-label="$t('share.close')"
          v-close-popup
        />
      </q-bar>

      <q-card-section>
        <div class="row helper-row q-mb-md">
          <div class="col-2 col-center">
            <p class="title">
              <img src="@/assets/icons/orbit-helper.svg" />
              {{ $t("navigation.orbit") }}
            </p>
          </div>
          <div class="col-10">
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.alt')"
            />
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.leftClick')"
            />
            <span class="connector">{{ $t("navigation.or") }}</span>
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.mouseWheelClick')"
            />
            <span class="connector">{{ $t("navigation.or") }}</span>
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.rightClick')"
            />
            <span class="connector">{{ $t("navigation.or") }}</span>
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.leftMouseClick')"
            />
          </div>
        </div>
        <div class="row helper-row q-mb-md">
          <div class="col-2 col-center">
            <p class="title">
              <img src="@/assets/icons/pan-helper.svg" />
              {{ $t("navigation.pan") }}
            </p>
          </div>
          <div class="col-10">
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.shift')"
            />
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.leftRightClick')"
            />
            <span class="connector">{{ $t("navigation.or") }}</span>
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.shift')"
            />
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.mouseWheelClick')"
            />
          </div>
        </div>

        <div class="row helper-row q-mb-md">
          <div class="col-2 col-center">
            <p class="title">
              <img src="@/assets/icons/zoom-helper.svg" />
              {{ $t("navigation.zoom") }}
            </p>
          </div>
          <div class="col-10">
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.trackpad')"
            />
            <span class="connector">{{ $t("navigation.or") }}</span>
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.mouseWheelScroll')"
            />
          </div>
        </div>
        <div class="row helper-row q-mb-md">
          <div class="col-2 col-center">
            <p class="title title--small">
              <img src="@/assets/icons/focus-helper.svg" />
              {{ $t("navigation.pivot") }}
            </p>
          </div>
          <div class="col-10">
            <q-chip
              class="key"
              outline
              square
              color="white"
              text-color="white"
              :label="$t('navigation.doubleLeftClick')"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    isOpen: true,
  },
  emits: ["helper-closed"],
  data() {
    return {
      open: this.isOpen,
    };
  },
  watch: {
    isOpen(newVal) {
      this.open = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.bar {
  background: var(--color-viewer-highlight);
  // The close button is absolutely positioned against this bar; without an
  // explicit position it resolved against the whole card and landed 200px low.
  position: relative;
}

// Kept out of the flow so the bar's title stays centred on the card rather
// than on the space left over beside the button.
.close-button {
  position: absolute;
  right: 0;
  // Centred on the bar rather than nudged upwards: the old `margin-top: -8px`
  // was what threw it off the vertical centre.
  top: 50%;
  transform: translateY(-50%);

  // Quasar colours the glyph itself, so setting `color` on the button is not
  // inherited — target the icon. Same ink as the bar's title, so the two read
  // as one header.
  :deep(.q-icon) {
    color: var(--color-grey800);
  }
}

.title {
  color: white;
  font-weight: 600;
  font-size: 20px;

  &--small {
    font-size: 17px;
  }
}

.key {
  font-size: 20px;
  margin-right: 8px;
  padding: 0;
}

.helper-card {
  width: 87%;
  max-width: 87%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background: var(--color-dark-bg-tertiary);
}

.connector {
  color: white;
  font-weight: 600;
  font-size: 20px;
  margin-right: 8px;
}

.col-center {
  margin: auto;
}

.os {
  color: white;
  font-size: 15px;
  font-weight: 400;
}

.mac-icon {
  color: white;
  font-size: 22px;
  font-weight: 400;
}

.header {
  color: var(--color-grey800);
  font-size: 20px;
  font-weight: 700;
}

.helper-row {
  background: var(--color-dark-bg-primary);
  padding: 8px;
  border-radius: 12px;
}
</style>
